<template>
  <div class="">
    <!-- Roles Section -->
    <div class="mb-4">
    

      <RolePermission
        :permissionConfig="permissionConfig"
        :resources="resources"
      />
    </div>

    <!-- CONFIRM MODAL -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text class="text-title">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>

    <!-- ROLE MODAL -->
    <b-modal
      ref="role"
      :title="modalTitle"
      centered
      cancel-variant="outline-secondary"
      hide-footer
    >
      <div style="color: black">
        <b-row>
          <!-- Role Name -->
          <b-col cols="12" md="6">
            <b-form-group>
              <div class="d-flex">
                <span class="font-weight-bold">Role Name</span>
              </div>

              <b-form-input v-model="roleName" placeholder="Enter role name" />
            </b-form-group>
          </b-col>

          <!-- Description -->
          <b-col cols="12" md="6">
            <b-form-group>
              <div class="d-flex">
                <span class="font-weight-bold">Description</span>
              </div>
              <b-form-input
                v-model="roleDescription"
                placeholder="Enter description"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <span class="font-weight-bold">Default Permissions</span>
        <div
          style="border: 1px solid #e0e0e0; border-radius: 10px; padding: 10px"
        >
          <div v-for="group in dataCreate" :key="group.title">
            <b-row class="px-1">
              <b-col
                v-for="permission in group.permissions"
                :key="permission.key"
                cols="12"
                class="mb-1"
                style="border: 1px solid #e0e0e0; border-radius: 5px"
              >
                <b-row>
                  <b-col sm="5">
                    <div class="py-1">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="">
                          <h6 class="m-0">{{ permission.title }}</h6>
                          <p
                            class="text-muted m-0"
                            style="
                              font-size: 10px;
                              line-height: 11px;
                              max-width: 120px;
                            "
                          >
                            {{ permission.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    sm="7"
                    class="d-flex justify-content-center align-items-center pr-2 cursor-pointer"
                    style="gap: 5px"
                  >
                    <div
                      v-for="item in permissionType"
                      :key="item"
                      class="text-capitalize"
                      style="
                        border-radius: 8px;
                        border: 1px solid #e0e0e0;
                        height: fit-content;
                        padding: 8px;
                      "
                      :class="[
                        {
                          'permission-active': permission.value === item,
                        },
                      ]"
                      @click="
                        handleSelectPermission(item, permission, group.key)
                      "
                    >
                      {{ item }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>

        <b-row class="mt-1">
          <b-col class="d-flex justify-content-end mt-1">
            <b-button
              variant="outline-secondary mr-1"
              @click="$refs.user.hide()"
            >
              Cancel
            </b-button>
            <template>
              <b-button
                v-if="modalTitle === 'Create Role Template'"
                variant="primary"
                class="mb-1 mb-sm-0"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                :disabled="loadingCreateRole"
                @click="handleCreateRole"
              >
                <Spinner v-if="loadingCreateRole" />
                <template v-else> Create Role Template </template>
              </b-button>
              <b-button
                v-else
                variant="primary"
                class="mb-1 mb-sm-0"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                :disabled="loadingCreateRole"
                @click="handleUpdateRole"
              >
                <Spinner v-if="loadingCreateRole" />
                <template v-else> Update Role Template </template>
              </b-button>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BIcon,
  BRow,
  BButton,
  BFormInput,
  BTable,
  BCardText,
  BFormGroup,
} from "bootstrap-vue";
import { computed, ref, watch } from "@vue/composition-api";
import useToastHandler from "@/services/toastHandler";
import { mapActions, mapState } from "vuex";
import { formatTime } from "@/helpers/utils";
import RolePermission from "./RolePermission.vue";
import Spinner from "@core/components/Spinner";
import { permissionConfig, resources } from "@/@core/utils/enum/user";

export default {
  components: {
    BIcon,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    RolePermission,
    BCardText,
    Spinner,
    BFormGroup,
  },
  data() {
    return {
      tableColumns: [
        { key: "roleId", label: "id" },
        { key: "name", label: "role name" },
        { key: "description" },
        { key: "totalUsers", label: "users" },
        { key: "createdDate" },
        { key: "actions" },
      ],
      type: "",
      modal: {
        title: "",
        content: "",
      },
      modalTitle: "",
      roleName: "",
      roleDescription: "",
      permissions: {},

      permissionType: ["none", "read", "write", "admin"],
      dataCreate: null,
      editItem: null,
    };
  },
  async created() {
    await this.getPermissionList({
      page: 1,
      limit: 100,
    });
    this.permissions = this.resources.reduce((accumulator, currentResource) => {
      accumulator[currentResource.key] = "";
      return accumulator;
    }, {});
  },
  computed: {
    ...mapState("user/admin", [
      "loadingDeleteRole",
      "loadingCreateRole",
      "loadingRoleList",
    ]),
    ...mapState("user/permission", ["dataListPermission"]),
    isSubmitting() {
      return this.loadingDeleteRole;
    },
    permissionGroups() {
      return Object.keys(this.permissionConfig).map((groupKey) => {
        const group = this.permissionConfig[groupKey];
        return {
          title: group.title,
          key: groupKey,
          permissions: Object.keys(group.permissions).map((permKey) => {
            const permConfig = group.permissions[permKey];
            const currentValue = this.permissions[permKey] || "";

            return {
              key: permKey,
              title: permConfig.title,
              description: permConfig.description,
              value: currentValue,
              enabled: true,
              disabled: false,
            };
          }),
        };
      });
    },
  },
  methods: {
    ...mapActions({
      getRoleList: "user/admin/getRoleList",
      deleteRole: "user/admin/deleteRole",
      createRole: "user/admin/createRole",
      getPermissionList: "user/permission/getPermissionList",
      getTotalRole: "user/statistic/getTotalRole",
    }),
    async fetchRoleList() {
      const data = await this.getRoleList({
        page: 1,
        limit: 100,
        additionalDetail: "withTotalUsers",
      });
      this.totalRoles = data.pagination.total;
      if (!data) return this.showToastError(false, "Error fetching role list");
      return data.data;
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };

      if (type === "delete")
        this.setModal(
          "Delete Role",
          `Are you sure you want to delete role ${item.name}?`
        );

      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;
      if (type === "delete") await this.handleDeleteRole(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDeleteRole(item) {
      const result = await this.deleteRole(item.roleId);
      if (!result) return;
      this.showToastSuccess("Success", "Delete role successfully!");
      this.refetchData();
      this.getTotalRole();
    },
    handleShowRoleModal() {
      this.modalTitle = "Create Role Template";
      this.dataCreate = Object.keys(this.permissionConfig).map((groupKey) => {
        const group = this.permissionConfig[groupKey];
        return {
          title: group.title,
          key: groupKey,
          permissions: Object.keys(group.permissions).map((permKey) => {
            const permConfig = group.permissions[permKey];
            const currentValue = this.permissions[permKey] || "";

            return {
              key: permKey,
              title: permConfig.title,
              description: permConfig.description,
              value: currentValue,
              enabled: true,
              disabled: false,
            };
          }),
        };
      });
      this.$refs.role.show();
    },
    handleSelectPermission(item, permission, key) {
      this.dataCreate = this.dataCreate.map((data) => {
        if (data.key !== key) return data;
        return {
          ...data,
          permissions: data.permissions.map((i) => {
            if (i.key === permission.key)
              return {
                ...i,
                value: item,
              };
            return i;
          }),
        };
      });
    },
    async handleCreateRole() {
      if (!this.roleName || !this.roleDescription)
        return this.showToastError("Error", "Please fill data to create role!");
      let list = [];
      const newDataCreate = [...this.dataCreate].map((i) => {
        const rolePermission = i.permissions.find((p) => p.key === "role");
        const listPermiss = i.permissions.map((p) => {
          if (p.key === "role") {
            return {
              ...p,
              title: "Roles",
            };
          }
          return p;
        });
        return {
          ...i,
          permissions:
            i.key !== "system"
              ? i.permissions
              : [
                  ...listPermiss,
                  {
                    ...rolePermission,
                    key: "user",
                    title: "Users",
                  },
                ],
        };
      });
      newDataCreate.forEach((item) => {
        item.permissions.forEach((permission) => {
          const permissionItems = this.dataListPermission
            .filter(
              (i) =>
                i.section === permission.title &&
                (i.code.includes(permission.value) ||
                  permission.value === "admin") &&
                permission.value !== "" &&
                permission.value !== "none"
            )
            .map((i) => i.permissionId);
          if (permissionItems.length > 0) list = [...list, ...permissionItems];
        });
      });
      const res = await this.createRole({
        code: this.roleName,
        description: this.roleDescription,
        name: this.roleName,
        ...(list.length > 0 && { permissionIds: list }),
      });
      if (res) {
        this.showToastSuccess(true, "New role created successfully!");
        this.refetchData();
        this.getTotalRole();
      }
      this.$refs.role.hide();
      this.resetModal();
    },
    resetModal() {
      this.roleName = "";
      this.roleDescription = "";
    },
    async handleShowEditModal(item) {
      this.editItem = item;
      this.roleName = item.name;
      this.roleDescription = item.description;
      const res = await this.getRoleList({
        page: 1,
        limit: 1,
        additionalDetail: "withPermissions",
        code: item.code,
      });
      this.modalTitle = "Edit Role Template - " + item.name;
      this.dataCreate = Object.keys(this.permissionConfig).map((groupKey) => {
        const group = this.permissionConfig[groupKey];
        return {
          title: group.title,
          key: groupKey,
          permissions: Object.keys(group.permissions).map((permKey) => {
            const permConfig = group.permissions[permKey];
            const currentValue =
              this.processPermissions(res.data[0].permissions)[permKey] || "";

            return {
              key: permKey,
              title: permConfig.title,
              description: permConfig.description,
              value: currentValue,
              enabled: true,
              disabled: false,
            };
          }),
        };
      });
      this.$refs.role.show();
    },
    processPermissions(permissionsList) {
      const groupedPermissions = {};

      if (permissionsList.some((i) => i.code.includes("full")))
        return this.resources.reduce((accumulator, currentResource) => {
          accumulator[currentResource.key] = "admin";
          return accumulator;
        }, {});

      permissionsList.forEach((p) => {
        const lastUnderscoreIndex = p.code.lastIndexOf("_");
        const sectionKey =
          lastUnderscoreIndex !== -1
            ? p.code.substring(0, lastUnderscoreIndex)
            : p.code;

        if (!groupedPermissions[sectionKey]) {
          groupedPermissions[sectionKey] = {
            read: false,
            write: false,
            delete: false,
          };
        }
        if (p.code.includes("_read")) {
          groupedPermissions[sectionKey].read = true;
        } else if (p.code.includes("_write")) {
          groupedPermissions[sectionKey].write = true;
        } else if (p.code.includes("_delete")) {
          groupedPermissions[sectionKey].delete = true;
        }
      });
      const finalData = {};
      for (const section in groupedPermissions) {
        const { read, write, delete: del } = groupedPermissions[section];

        if (read && write && del) {
          finalData[section] = "admin";
        } else if (write) {
          finalData[section] = "write";
        } else if (read) {
          finalData[section] = "read";
        } else {
          finalData[section] = "none";
        }
      }

      const allSections = this.resources.map((resource) => resource.key);
      allSections.forEach((section) => {
        if (!finalData[section]) {
          finalData[section] = "none";
        }
      });
      return finalData;
    },
    async handleUpdateRole() {
      if (!this.roleName || !this.roleDescription)
        return this.showToastError("Error", "Please fill data to create role!");
      let list = [];
      this.dataCreate.forEach((item) => {
        item.permissions.forEach((permission) => {
          const permissionItems = this.dataListPermission
            .filter(
              (i) =>
                i.section === permission.title &&
                (i.code.includes(permission.value) ||
                  permission.value === "admin") &&
                permission.value !== "" &&
                permission.value !== "none"
            )
            .map((i) => i.permissionId);
          if (permissionItems.length > 0) list = [...list, ...permissionItems];
        });
      });
      const res = await this.createRole({
        code: this.editItem.code,
        description: this.roleDescription,
        name: this.roleName,
        ...(list.length > 0 && { permissionIds: list }),
      });
      if (res) {
        this.showToastSuccess(true, "This role updated successfully!");
        this.refetchData();
      }
      this.$refs.role.hide();
      this.resetModal();
    },
  },
  setup() {
    const refRoleListsTable = ref(null);
    const totalRoles = ref(0);
    const currentPage = ref(1);
    const perPage = ref(100);

    const dataMeta = computed(() => {
      const localItemsCount = refRoleListsTable.value
        ? refRoleListsTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalRoles.value,
      };
    });

    const refetchData = () => {
      refRoleListsTable.value.refresh();
    };

    watch([currentPage], () => {
      refetchData();
    });

    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,

      refRoleListsTable,

      totalRoles,
      currentPage,
      perPage,
      dataMeta,

      formatTime,
      refetchData,
      permissionConfig,
      resources,
    };
  },
};
</script>

<style scoped>
.text-title {
  color: black;
}
.permission-active {
  background: #000;
  color: white;
}
</style>
